export default {
  aboutPage: {
    title: "Frederic-K",
    subtitle: "Full-Stack Software Developer",
    catchphrase:
      "Passionate about innovation, I love combining technology, creativity, and collaboration for human-centered solutions.",
    summaryTitle: "A Journey through Projects, Challenges, and Meetings",
    summaryText:
      "Driven by a passion for technology and a curiosity for innovation, I thrive on projects that merge technical expertise with human interaction. My journey has equipped me with a diverse skill set, ranging from software development to system administration and communication. I excel in deploying and managing innovative solutions, always with a focus on listening, collaborating, and supporting those around me. Today, I am eager to channel my skills into projects that inspire and challenge me, creating impactful solutions that resonate with people.",
    profileTitle: "Profile",
    devSkillTitle: "Technologies",
    globalSkillTitle: "Skills",
    skillsWordCloud: "Word cloud of skills",
    referencesTitle: "References",
    references: {
      laurentReber2024: {
        text: "Monsieur Frédéric Kreuder worked under my supervision in the Non-Dematerialized Incoming Flows department at Urssaf Alsace from 2013 to 2019 as a technical referent responsible for mastering the processing chain of incoming flows, tools, and their configuration. Mr. Kreuder is a serious and rigorous collaborator who is committed to his work and is dedicated to successfully completing the tasks assigned to him and achieving the set objectives. He is also proactive in his field of activity, seeking simplifications and productivity gains. Ready to take on new missions, Mr. Kreuder is motivated to join your teams, and I recommend his application. I thank you in advance for the attention you will give to his request. The General Administration Manager of Urssaf Alsace.",
        author: "Laurent REBER",
        date: "04/09/2024",
      },
      herveKoell2024: {
        text: "Serious and conscientious, it was a pleasure to work with Frédéric. The friendly exchanges, both professional and private, allowed projects to progress in a certain serenity. I appreciated working and exchanging ideas with him.",
        author: "Hervé KOELL",
        date: "03/07/2024",
      },
      yousriTabbakh2023: {
        text: "I had the privilege of mentoring Frédéric during his training as a React Developer on OpenClassrooms. His motivation and desire to acquire new knowledge exceeded my expectations. Moreover, he managed to develop his programming skills at a remarkable pace. I am convinced that his commitment to future projects will be an extremely valuable contribution.",
        author: "Yousri TABBAKH",
        date: "11/28/2023",
      },
    },
    programTitle: "Program",
    program: {
      fullStackMERN: {
        title: "Full-Stack Developer – MERN",
        from: "Self-taught",
        // date: "2024",
      },
      javascriptReact: {
        title: "Software Developer – JavaScript React",
        from: "Openclassrooms",
        // date: "2023",
      },
      teamLeader: {
        title: "Team Leadership",
        from: "Cirfe",
        // date: "2013",
      },
      conflictManagement: {
        title: "Conflict Management",
        from: "Cirfe",
        // date: "2013",
      },
      BTS: {
        title: "Advanced Technician's Certificate in SME/SMI Management",
        from: "Private Commercial School",
        // date: "2000",
      },
    },
    interestTitle: "Domains of Interest",
    interests: {
      technology: "Technology",
      art: "Art",
      literature: "Literature",
      gaming: "Gaming",
      cooking: "Cooking",
      gardening: "Gardening",
    },
  },
  // ... other translations
}
